import type { TeactNode } from '../../lib/teact/teact';

import type { LangFn } from './types';

const UNIQUE_PLACEHOLDER_PREFIX = '$PLACEHOLDER-';

export function conjuctionWithNodes(langFn: LangFn, nodes: TeactNode[]) {
  const conjunction = langFn.internalFormatters?.conjunction;
  if (!conjunction?.formatToParts) {
    return fallbackJoinNodes(nodes);
  }
  const placeholders = nodes.map((node, i) => `${UNIQUE_PLACEHOLDER_PREFIX}${i}`);
  const replaced = conjunction.formatToParts(placeholders);
  const result: TeactNode[] = [];
  replaced.forEach((part) => {
    if (part.type === 'literal') {
      result.push(part.value);
      return;
    }

    const index = Number(part.value.slice(UNIQUE_PLACEHOLDER_PREFIX.length));
    result.push(nodes[index]);
  });

  return result;
}

export function disjunctionWithNodes(langFn: LangFn, nodes: TeactNode[]) {
  const disjunction = langFn.internalFormatters?.disjunction;
  if (!disjunction?.formatToParts) {
    return fallbackJoinNodes(nodes);
  }
  const placeholders = nodes.map((node, i) => `${UNIQUE_PLACEHOLDER_PREFIX}${i}`);
  const replaced = disjunction.formatToParts(placeholders);
  const result: TeactNode[] = [];
  replaced.forEach((part) => {
    if (part.type === 'literal') {
      result.push(part.value);
      return;
    }

    const index = Number(part.value.slice(UNIQUE_PLACEHOLDER_PREFIX.length));
    result.push(nodes[index]);
  });

  return result;
}

function fallbackJoinNodes(nodes: TeactNode[]): TeactNode[] {
  if (nodes.length <= 1) return nodes;
  const result: TeactNode[] = [];
  nodes.forEach((node, i) => {
    if (i > 0) result.push(', ');
    result.push(node);
  });
  return result;
}
